import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "TN_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#TN_svg__a)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v24h32V0H0z",
      fill: "#E31D1C"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "TN_svg__b",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 0v24h32V0H0z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#TN_svg__b)", fillRule: "evenodd", clipRule: "evenodd" }, /* @__PURE__ */ e.createElement("path", { d: "M16 20a8 8 0 100-16 8 8 0 000 16z", fill: "#F7FCFF" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M17.402 17.651s-4.216-1.15-4.216-5.677c0-4.527 4.216-5.776 4.216-5.776-1.743-.675-6.845.36-6.845 5.776 0 5.415 5.244 6.39 6.845 5.677zm-.232-6.662l-2.092.764 2.249.786.075 2.105 1.369-1.635 2.256.16-1.626-1.326.98-1.915-1.913.643-1.325-1.656.027 2.074z",
      fill: "#E31D1C"
    }
  )))
), a = t;
export {
  a as default
};
